import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { AnimationContents } from '../../../../AnimationContents';
import { GameLogic } from '../../../Logic/GameLogic';
import { GameModel } from '../../../Models/GameModel';

export interface ITooltipControllerOptions {
    text: string;
    isDone: boolean;
}

export class TooltipController extends AnimationBaseController {
    public $model: GameModel;

    private _dialogWidth: number = 0;

    /*
    private _text: string[] = [
        'Моряк, время на исходе. Нужно быстрее разобраться с текущими делами.',
        'Времени на подготовку судна все меньше, а надо еще столько всего успеть!'
    ]
     */

    public constructor(
        @Inject private _options: ITooltipControllerOptions,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('TooltipController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.HURRYUP_SCREEN_JSON,
            libraryName: 'HurryUpMsg',
            onPointerDown: () => {
                this._gameLogic.hideTooltip();
            },
        };
    }

    protected onInitialize(): void {
        this._dialogWidth = this.width;

        this.gotoAndStop(this._options.isDone ? 1 : 0);
        this.setTextByQuery('msgText', this._options.text);

        setTimeout(() => {
            this._gameLogic.hideTooltip();
        }, 5000);
    }

    protected onResize(width: number, height: number, scale: number) {
        const scaleValue = width / scale / 3000;

        this.y = height / scale / 2 - 100;
        this.scaleX = scaleValue;
        this.scaleY = scaleValue;
    }
}
